import React from "react";
import SliderProgressBar from "../SliderProgressBar";
import ExercisesBar from "../../ExercisesBar/ExercisesBar";
import classes from "./ActivityXpAndExercises.module.sass";
import iconPain from "../../Score/assets/pain.svg";
import brokenHeart from '../../../../../../assets/images/heart-broken.svg'
function ActivityXpAndExercises({
  score,
  exercises,
  colors,
  sessionId,
  statusSlider,
  license,
  pain,
  aboveAlert
}) {
  if (!score || !exercises) return null;

  return (
    <div className={classes.wrapper}>
      <div className={classes.row}>
        {/* Barra XP */}
        <div className={classes.progressColumn}>
          {score.value !== null && (<SliderProgressBar
            score={score.value}
            colors={colors}
            sessionId={sessionId}
            statusSlider={statusSlider}
          />)}
        </div>



        {/* XP */}
        <div className={classes.xpColumn} >
          {score.value !== null &&
            <>
              <span className={classes.xp} style={{ color: colors.primaryColor }}>{score.value}</span>
              <span className={classes.xpUnit}>XP</span>
            </>
          }
        </div>
        <img
          src={brokenHeart}
          className={classes.noteIconImage}
          style={{ opacity: aboveAlert ? 1 : 0 }}
        />
        <img
          src={iconPain}
          className={classes.noteIconImage}
          style={{ opacity: pain ? 1 : 0 }}
        />

      </div>
      {/* Badge esercizi */}
      <div className={classes.badgesColumn}>
        <ExercisesBar exercises={exercises.badges} colors={colors} />
        {/* Testo “7 su 13 ESERCIZI” */}
        {exercises.done >= 0 &&
          <div className={classes.counterColumn}>
            <span className={classes.counter} style={{ color: colors.primaryColor }}>
              {exercises.done}
            </span>
            <span className={classes.label}>/{exercises.todo} {exercises.label}</span>
          </div>
        }
        {exercises.duration &&
          <div className={score.value !== null ? classes.counterColumnDuration : classes.counterColumnDurationWithoutXp}>
            <span className={classes.label}>{exercises.title}</span>
            <span className={classes.counter} style={{ color: colors.primaryColor }}>
              {exercises.duration}  {exercises.durationLabel}
            </span>

          </div>
        }
      </div>


    </div>
  );
}

export default ActivityXpAndExercises;
